<template>
  <div>
    <deliver-print-order ref="orders" @clearDetails="clearDetails" @showDetails="showDetails"/>
    <deliver-print-detail ref="details"/>
  </div>
</template>

<script>
import DeliverPrintOrder from '@/views/outbound/order_print/DeliverPrintOrder.vue'
import DeliverPrintDetail from '@/views/outbound/order_print/DeliverPrintDetail.vue'

export default {
  name: 'DeliverPrint',
  components: { DeliverPrintOrder, DeliverPrintDetail },
  data() {
    return {}
  },
  methods: {
    refresh() {
      this.$refs.orders.refresh()
    },
    showDetails(row) {
      this.$refs.details.refresh(row.order.id)
    },
    clearDetails() {
      this.$refs.details.clear()
    }
  }
}
</script>